var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignUpArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 139.805,
    height: 135.279,
    viewBox: "0 0 139.805 135.279",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1475",
    "data-name": "Rectangle 1475",
    width: 44.738,
    height: 52.818,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1523",
    "data-name": "Rectangle 1523",
    width: 103.009,
    height: 50.712,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2564",
    "data-name": "Group 2564",
    transform: "translate(-1564.794 -3696.245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2214",
    "data-name": "Group 2214",
    transform: "matrix(0.875, 0.485, -0.485, 0.875, 1665.47, 3696.245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M16.963,31.287l.653,5.219a57.144,57.144,0,0,1,1.3,10.44c.653,4.566.653,5.871,1.958,5.871.652,0,1.3-.652,1.3-4.567a14.556,14.556,0,0,1,1.958-8.481c3.914-7.176,3.262-7.176,11.744-7.176,7.829,0,9.787,0,8.482-1.957a49.151,49.151,0,0,1-3.914-8.482c0-.652-.653-5.871-.653-11.744,0-11.092,0-11.744-2.609-9.135C14.354,20.2,4.567,27.372,2.609,26.719,0,26.719,0,27.372,0,28.677c0,.653,0,1.305.652,1.305a67.322,67.322,0,0,1,9.135.653Zm7.829,4.567c-.652,1.305-1.957,3.262-1.957,3.914-.653,1.305-.653,1.305-.653-.652-.652-2.61.653-6.524,1.958-5.872a2.023,2.023,0,0,0,1.305-.652c1.3-.653,1.3,0-.653,3.262m12.4-28.708.652,4.567c1.305,11.092,1.957,14.354,2.61,16.311.652,1.305.652,1.957,0,2.61a72.709,72.709,0,0,1-12.4,0c-1.957-.653-2.609-.653-1.957-1.958a122.782,122.782,0,0,1,9.134-18.92ZM15.006,21.5c3.914-3.262,10.44-8.482,13.049-11.092,5.872-4.567,7.829-5.219,4.567-1.957-.652,1.305-2.61,3.262-3.262,5.219l-2.61,3.915q-.978,0-1.957,1.957c0,.652-1.957,3.262-3.262,5.871-2.61,3.262-2.61,3.262-5.219,3.262H9.787l-3.262-.652Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2215",
    "data-name": "Group 2215",
    transform: "translate(1564.794 3810.897) rotate(-66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M58.785,43.6c-5.607,1.246-14.327.623-21.179-1.246-8.1-1.868-10.589-3.114-14.948-6.852C8.953,24.293,2.1,15.572.234,6.229-.389,1.869.234,0,2.1,0c.623,0,.623,0,.623.623C.234,5.606,5.216,16.818,13.937,25.538c9.343,9.344,13.7,12.458,21.8,14.95,6.229,1.868,7.475,1.868,14.327,1.868A40.635,40.635,0,0,0,60.653,41.11c2.491,0,6.851-.622,13.08-.622,9.343,0,14.949,1.245,20.555,3.737a10.909,10.909,0,0,0,3.115.623,4.822,4.822,0,0,0-.623-1.869c-1.245-1.246-1.245-1.246,0-1.246.623,0,1.869.623,2.491,2.492,1.247,1.246,2.492,3.114,3.115,3.114a3.746,3.746,0,0,1,.623,2.492c0,.623,0,1.246-.623.623s-3.737-.623-6.851-.623a34.435,34.435,0,0,1-5.607-.623c-1.869-.623,0-1.246,3.737-1.869,1.87,0,3.115,0,3.115-.623-1.245-1.245-10.589-3.737-15.572-3.737-6.852-.623-17.441-.623-22.423.623",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUpArrow);
export default __webpack_public_path__ + "static/media/sign-up-arrow.a605de5484937a621a1e1a43792d6ab3.svg";
export { ForwardRef as ReactComponent };